























import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import { ApexOptions } from 'apexcharts';
import DonutChart from '../../../common/Chart/DonutChart.vue';

export default Vue.extend({
  components: {
    apexchart: VueApexCharts,
    DonutChart,
  },
  data(): {
    donutLabels: string[];
    donutColors: string[];

    barChartOptions: ApexOptions;
  } {
    return {
      donutLabels: ['정상', '손상'],
      donutColors: ['#24BE99', '#F8791D'],

      barChartOptions: {
        chart: {
          stacked: true,
          stackType: '100%',
          toolbar: {
            show: false,
          },
          offsetY: 0,
        },
        colors: ['#F8791D', '#FF974D', '#FBB500', '#FBCC38'],
        xaxis: {
          position: 'top',
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          categories: ['Error'],
        },
        yaxis: {
          show: false,
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: 'right',
          fontSize: '12px',
          show: true,
          inverseOrder: true,
        },
        dataLabels: {
          enabled: false,
        },
      },
    };
  },
  computed: {
    donutSeries() {
      return [
        this.$store.getters.totalDataNumber -
          this.$store.getters.corruptedFileList.length,
        this.$store.getters.corruptedFileList.length,
      ];
    },
    barSeries() {
      let corruptedFileDictionary: Record<string, number> = {};
      this.$store.getters.corruptedFileList.forEach(
        (x: { file: string; target_lib: string[] }) => {
          for (let target of x.target_lib) {
            if (
              Object.keys(corruptedFileDictionary).includes(target) === false
            ) {
              corruptedFileDictionary[target] = 1;
            } else {
              corruptedFileDictionary[target] += 1;
            }
          }
        },
      );

      let barSeriesChanged: { name: string; data: number[] }[] = [];
      Object.keys(corruptedFileDictionary).forEach((x: string): void => {
        barSeriesChanged.push({ name: x, data: [corruptedFileDictionary[x]] });
      });
      return barSeriesChanged;
    },
  },
});
